import * as caretakerResponseRequestManager from '$domain/model/caretaker/caretakerServiceResponse/caretakerServiceResponse.manager'
import { tagManager } from '$infrastructure/tagManager/tagManager'

export const acceptService = (serviceId: string) => {
  tagManager.push({
    event: 'fam',
    fam_id: 'SignUpForOffer',
  })
  return caretakerResponseRequestManager.caretakerAcceptService(serviceId)
}



// WEBPACK FOOTER //
// ./src/services/caretaker/acceptService/acceptService.service.ts